import dynamic from "next/dynamic";
import { When } from "@/components/common/When";
import Layout from "@/components/layout/Layout";
import { BlogMain } from "./shared/BlogMain";
import { BlogTitle } from "./shared/BlogTitle";
import AboutAuthor from "../author-page/components/about-author/AboutAuthor";
import CTA from "./shared/CTA/CTA";
import { RelatedBlogs } from "./shared/RelatedBlogs";
import { BlogCardType } from "@/components/page-modules/blog/data/blog.types";
import TypesPreview from "@/components/page-modules/home-page/GenerateTypes/TypesPreview/TypesPreview";
import style from "./BlogPage.module.scss";
export const BlogContainer: React.FC<BlogCardType> = ({
  blogData
}) => {
  return <Layout nav footer data-sentry-element="Layout" data-sentry-component="BlogContainer" data-sentry-source-file="BlogContainer.tsx">
      <When condition={!!blogData?.qrType} data-sentry-element="When" data-sentry-source-file="BlogContainer.tsx">
        <div className={style.creator_wrap}>
          <TypesPreview data-sentry-element="TypesPreview" data-sentry-source-file="BlogContainer.tsx" />
        </div>
      </When>
      <div className={style.container}>
        <div className={style.flex}>
          <When condition={!!blogData} data-sentry-element="When" data-sentry-source-file="BlogContainer.tsx">
            <BlogTitle blogData={blogData} data-sentry-element="BlogTitle" data-sentry-source-file="BlogContainer.tsx" />
            <BlogMain blogData={blogData} data-sentry-element="BlogMain" data-sentry-source-file="BlogContainer.tsx" />
          </When>

          <When condition={!!blogData.author} data-sentry-element="When" data-sentry-source-file="BlogContainer.tsx">
            <div className={style.aboutAuthor_wrap}>
              <AboutAuthor authorData={blogData.author} isWithinBlogPage data-sentry-element="AboutAuthor" data-sentry-source-file="BlogContainer.tsx" />
            </div>
          </When>

          <When condition={blogData?.relatedBlogs && blogData.relatedBlogs?.length > 0} data-sentry-element="When" data-sentry-source-file="BlogContainer.tsx">
            <RelatedBlogs title="Related Articles" blogs={blogData?.relatedBlogs} data-sentry-element="RelatedBlogs" data-sentry-source-file="BlogContainer.tsx" />
          </When>
          <CTA data-sentry-element="CTA" data-sentry-source-file="BlogContainer.tsx" />
        </div>
      </div>
    </Layout>;
};